export default __webpack_public_path__ + "static/media/rice06.b11ed4e1.png";